import { map, takeUntil } from "rxjs/operators";
import { Injectable } from "@angular/core";
import { Baseservice } from "./baseservice";
import { AuthenticationService } from "./authentication.service";

import { HttpClient } from "@angular/common/http";
import { Subject } from "rxjs";
import { environment } from "environments/environment";
declare var printJS: any;

@Injectable()
export class DocumentsServiceService extends Baseservice {
  private destroy$: Subject<void> = new Subject<void>();

  constructor(http: HttpClient, authentication: AuthenticationService) {
    super("document", http, authentication);
  }
  get() {
    return this.getDocument(this.url + "/document");
  }

  getById(id: any) {
    return this.getDocument(this.url + "/find/" + id);
  }
  getByCarrierId(id: any) {
    return this.getDocument(this.url + "/list/" + id);
  }
  getDocument(url: string) {
    return this.getRequest(url).pipe(map((response) => response));
  }

  checkIfKiosk() {
    return this.http.get(`${environment.consoleAPIUrl}/getpcdetails`);
  }

  scanDocument() {
    return this.http
      .get(`${environment.consoleAPIUrl}/scan`, { responseType: "blob" })
      .pipe(
        map((res: any) => {
          return new Blob([res], { type: "application/pdf" });
        })
      );
  }
  download(id: any) {
    return this.http
      .get(this.url + "/download/" + id, { responseType: "blob" })
      .pipe(
        map((res: any) => {
          return new Blob([res], { type: "image/png" });
        })
      );
  }
  downloadpdf(id: any) {
    return this.http
      .get(this.url + "/download/" + id, { responseType: "blob" })
      .pipe(
        map((res: any) => {
          return new Blob([res], { type: "application/pdf" });
        })
      );
  }

  //Create new document
  postDocument(object: any, typeid: any, invoiceid: any) {
    //alert(this.url);
    const body = object;
    return this.http.post(this.url, body);
  }
  postPermitDocument(object: any, typeid?: any, invoiceid?: any) {
    const body = object;
    return this.http.post(this.url + "/save-permit", body);
  }

  //Update a document
  putDocument(object: any) {
    const body = object;
    return this.update(body);
  }

  //Delete a document
  deleteDocument(id: number) {
    return this.delete(id).pipe(map((response) => response));
  }

  deleteComplianceDocs(id: number) {
    return this.http.get(this.url + "/delete-permit/" + id);
  }

  useDocumentForCompliance(body) {
    return this.http.post(this.url + "use-this-document", body);
  }

  getAttachements(id: number) {
    const url = this.url + "/list/" + id;
    return this.getDocument(url);
  }

  downloadFiles(id: number) {
    return this.http.get(this.url + "/find/" + id);
  }

  DeleteFromTemp(object: any) {
    const body = object;
    return this.http.post(this.url + "/destroy", body);
  }
  DeletePermitDoc(id: any) {
    return this.http.get(this.url + "/delete-permit/" + id);
  }

  DeletePaxDoc(id: any) {
    return this.http.get(this.url + "/delete-scan-pax/" + id);
  }
  PostVehicleEntryDocument(object: any, typeid: any, invoiceid: any) {
    const body = object;
    console.log("Document body" + object);
    return this.http.post(this.url + "/save-vehicle-entry", body);
  }
  PostMCScans(object: any) {
    const body = object;
    return this.http.post(this.url + "/save-scan-doc", body);
  }
  DeleteVehicleEntryDoc(id: any) {
    return this.http.get(this.url + "/delete-vehicle/" + id);
  }
  getVehicleEntryDocById(id: any) {
    return this.getRequest(this.url + "/vehicle-doc-list/" + id);
  }

  uploadPaxList = (doc) => {
    ////console.log('Form Data : ', doc);
    return this.http.post(`${this.url}/pax`, doc);
  };

  useThisDocument(body) {
    return this.http.post(`${this.url}/use-this-document`,body);
  }

  getComplianceTrip(id) {
    return this.http.get(`${this.url}/compliance-trip/` + id);
  }

  postComplianceDocument(object: any, typeid?: any, invoiceid?: any) {
    const body = object;
    return this.http.post(this.url + "/save-complaince", body);
  }


}
